// extracted by mini-css-extract-plugin
module.exports = {"base":"LinkButton_base__33Qh7","danger":"LinkButton_danger__13XF0","stickLeft":"LinkButton_stickLeft__3Gre8"};